// − / + buttons around a quantity field (shared/_quantity_stepper). Steps stay
// within the field's min/max, and each step fires input + change so listeners
// such as add_to_cart_quantity.js stay in sync.
function bounds($input) {
  return {
    min: parseInt($input.attr("min"), 10) || 1,
    max: parseInt($input.attr("max"), 10) || 99,
  }
}

function syncButtons($stepper) {
  var $input = $stepper.find("input")
  var limits = bounds($input)
  var value = parseInt($input.val(), 10)
  var disabled = $input.prop("disabled")

  $stepper
    .find('.js-qty-step[data-step="-1"]')
    .prop("disabled", disabled || !(value > limits.min))
  $stepper
    .find('.js-qty-step[data-step="1"]')
    .prop("disabled", disabled || !(value < limits.max))
}

$(document).on("click", ".js-qty-step", function () {
  var $stepper = $(this).closest(".js-qty-stepper")
  var $input = $stepper.find("input")
  var limits = bounds($input)
  var current = parseInt($input.val(), 10) || limits.min
  var next = Math.min(
    Math.max(current + parseInt($(this).data("step"), 10), limits.min),
    limits.max
  )

  if (next !== current) {
    $input.val(next).trigger("input").trigger("change")
  }
})

$(document).on("input change", ".js-qty-stepper input", function () {
  syncButtons($(this).closest(".js-qty-stepper"))
})

// Out-of-range typing is clamped once the field is left.
$(document).on("blur", ".js-qty-stepper input", function () {
  var $input = $(this)
  var limits = bounds($input)
  var value = parseInt($input.val(), 10)
  var clamped = Math.min(Math.max(value || limits.min, limits.min), limits.max)

  if (clamped !== value) $input.val(clamped).trigger("change")
})
